import React, { useEffect, useMemo, useRef } from "react";
import Dropdown from "../Form/Dropdown";
import Form from "../Form";
import { connect } from "react-redux";
import Labels from "../../services/apiLabels";
import { POST } from "../../constant/apiMethods";
import { BRANDS } from "../../constant/index";
import { API_ENDPOINT } from "../../services/api";
import { useContext } from "react";
import FeedbackContext from "../../context/cmscontext";

function normalizeList(payload) {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.results)) return payload.results;
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
}

async function getdata(label) {
  const response = await fetch(API_ENDPOINT(label), {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  const json = await response.json();
  return normalizeList(json);
}

const emptyFieldState = {
  fetching: false,
  data: [],
  isSelected: false,
  current: {},
  empty: false,
};

let reduxType_ = "SELL_MY_CAR_STEPS";

function CarDetailForm(props) {
  const {
    formWidth,
    title,
    fetchingBrands,
    getbrands,
    brands,
    onSubmit,
    buttonText,
    setbrand,
    setmodel,
    setfuelType,
    setyear,
    setvariant,
    reduxType,
    reducer,
    loading,
    childClassName,
    buttonClassName,
  } = props;

  useContext(FeedbackContext);

  const brand = props[reducer].step1.brand.current || {};
  const model = props[reducer].step1.model || emptyFieldState;
  const fuel_type = props[reducer].step1.fuel_type || emptyFieldState;
  const year = props[reducer].step1.year || emptyFieldState;
  const variant = props[reducer].step1.variant || emptyFieldState;

  const requestIdRef = useRef({
    model: 0,
    fuel: 0,
    year: 0,
    variant: 0,
  });

  useEffect(() => {
    reduxType_ = reduxType;
    if (!brands || brands.length < 1) getbrands();
  }, []);

  const onSubmitHandler = () => {
    onSubmit();
  };

  const brandOnSelectHandler = async (item = {}) => {
    if (!item.id) return;

    const reqId = ++requestIdRef.current.model;
    setbrand({ isSelected: true, current: item });
    setmodel({ ...emptyFieldState, fetching: true });
    setfuelType({ ...emptyFieldState });
    setyear({ ...emptyFieldState });
    setvariant({ ...emptyFieldState });

    try {
      const data = await getdata(`${Labels.car_models}${item.id}/`);
      if (reqId !== requestIdRef.current.model) return;
      if (data.length > 0) {
        setmodel({
          data,
          fetching: false,
          isSelected: false,
          current: {},
          empty: false,
        });
      } else {
        setmodel({ ...emptyFieldState, empty: true });
      }
    } catch {
      if (reqId !== requestIdRef.current.model) return;
      setmodel({ ...emptyFieldState, empty: true });
    }
  };

  const modelsOnSelectHandler = async (item) => {
    if (!item?.value) return;

    const reqId = ++requestIdRef.current.fuel;
    setmodel({ ...model, isSelected: true, current: item, empty: false });
    setfuelType({ ...emptyFieldState, fetching: true });
    setyear({ ...emptyFieldState });
    setvariant({ ...emptyFieldState });

    try {
      const data = await getdata(`${Labels.car_fuel_types}${item.value}/`);
      if (reqId !== requestIdRef.current.fuel) return;
      if (data.length > 0) {
        setfuelType({
          data,
          fetching: false,
          isSelected: false,
          current: {},
          empty: false,
        });
      } else {
        setfuelType({ ...emptyFieldState, empty: true });
      }
    } catch {
      if (reqId !== requestIdRef.current.fuel) return;
      setfuelType({ ...emptyFieldState, empty: true });
    }
  };

  const fuelTypeOnSelectHandler = async (item) => {
    if (!item?.value) return;

    const reqId = ++requestIdRef.current.year;
    setfuelType({
      ...fuel_type,
      isSelected: true,
      current: item,
      empty: false,
    });
    setyear({ ...emptyFieldState, fetching: true });
    setvariant({ ...emptyFieldState });

    try {
      const data = await getdata(`${Labels.car_years}${item.value}/`);
      if (reqId !== requestIdRef.current.year) return;
      if (data.length > 0) {
        setyear({
          data,
          fetching: false,
          isSelected: false,
          current: {},
          empty: false,
        });
      } else {
        setyear({ ...emptyFieldState, empty: true });
      }
    } catch {
      if (reqId !== requestIdRef.current.year) return;
      setyear({ ...emptyFieldState, empty: true });
    }
  };

  const yearsOnSelectHandler = async (item) => {
    if (!item?.value) return;

    const reqId = ++requestIdRef.current.variant;
    setyear({ ...year, isSelected: true, current: item, empty: false });
    setvariant({ ...emptyFieldState, fetching: true });

    try {
      const data = await getdata(`${Labels.car_variants}${item.value}/`);
      if (reqId !== requestIdRef.current.variant) return;
      if (data.length > 0) {
        setvariant({
          data,
          fetching: false,
          isSelected: false,
          current: {},
          empty: false,
        });
      } else {
        setvariant({ ...emptyFieldState, empty: true });
      }
    } catch {
      if (reqId !== requestIdRef.current.variant) return;
      setvariant({ ...emptyFieldState, empty: true });
    }
  };

  const variantsOnSelectHandler = (item) => {
    if (!item?.value) return;
    setvariant({
      ...variant,
      isSelected: true,
      current: item,
      empty: false,
    });
  };

  const brandList = useMemo(() => normalizeList(brands), [brands]);
  const modelReady = !model.fetching && Array.isArray(model.data) && model.data.length > 0;
  const fuelReady =
    !fuel_type.fetching &&
    Array.isArray(fuel_type.data) &&
    fuel_type.data.length > 0;
  const yearReady =
    !year.fetching && Array.isArray(year.data) && year.data.length > 0;
  const variantReady =
    !variant.fetching && Array.isArray(variant.data) && variant.data.length > 0;

  return (
    <Form
      width={formWidth}
      loading={loading}
      loadingText="Submitting Interest ..."
      title={title}
      onSubmit={onSubmitHandler}
      buttonText={buttonText}
      childClassName={childClassName}
      buttonClassName={buttonClassName}
    >
      <Dropdown
        label="Brand"
        onSelect={brandOnSelectHandler}
        titleKey="brand_name"
        idKey="id"
        selectedValue={brand}
        loading={fetchingBrands}
        disabled={fetchingBrands || loading || brandList.length < 1}
        data={brandList}
        invalid={!fetchingBrands && brandList.length < 1}
        errorText={
          !fetchingBrands && brandList.length < 1
            ? "No brands available right now."
            : ""
        }
      />

      <Dropdown
        label="Model"
        onSelect={modelsOnSelectHandler}
        titleKey="display"
        idKey="value"
        selectedValue={model.current}
        loading={model.fetching}
        disabled={!modelReady || loading}
        data={model.data}
        invalid={Boolean(model.empty)}
        errorText={
          model.empty ? "No models found for this brand." : ""
        }
      />

      <Dropdown
        label="Fuel Type"
        onSelect={fuelTypeOnSelectHandler}
        titleKey="display"
        idKey="value"
        selectedValue={fuel_type.current}
        loading={fuel_type.fetching}
        disabled={!fuelReady || loading}
        data={fuel_type.data}
        invalid={Boolean(fuel_type.empty)}
        errorText={
          fuel_type.empty ? "No fuel types found for this model." : ""
        }
      />

      <Dropdown
        label="Year"
        onSelect={yearsOnSelectHandler}
        titleKey="display"
        idKey="value"
        selectedValue={year.current}
        loading={year.fetching}
        disabled={!yearReady || loading}
        data={year.data}
        invalid={Boolean(year.empty)}
        errorText={year.empty ? "No years found for this fuel type." : ""}
      />

      <Dropdown
        label="Variant"
        onSelect={variantsOnSelectHandler}
        titleKey="display"
        idKey="value"
        selectedValue={variant.current}
        loading={variant.fetching}
        disabled={!variantReady || loading}
        data={variant.data}
        invalid={Boolean(variant.empty)}
        errorText={
          variant.empty ? "No variants found for this year." : ""
        }
      />
    </Form>
  );
}

const mapStateToProps = (state) => ({
  fetchingBrands: state.sellMyCar.fetchingBrands,
  brands: state.sellMyCar.brands,
  showInterest: state.showInterest,
  sellMyCar: state.sellMyCar,
});

const mapDispatchToProps = (dispatch) => ({
  getbrands: () =>
    dispatch({
      type: BRANDS,
      payload: {
        type: BRANDS,
        method: POST,
        label: `${Labels.brands}`,
        hideOverlayLoader: true,
      },
    }),
  setbrand: (data) =>
    dispatch({
      type: reduxType_,
      payload: { type: "brand", data },
    }),
  setmodel: (data) =>
    dispatch({
      type: reduxType_,
      payload: { type: "model", data },
    }),
  setfuelType: (data) =>
    dispatch({
      type: reduxType_,
      payload: { type: "fuel_type", data },
    }),
  setyear: (data) =>
    dispatch({
      type: reduxType_,
      payload: { type: "year", data },
    }),
  setvariant: (data) =>
    dispatch({
      type: reduxType_,
      payload: { type: "variant", data },
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(CarDetailForm);
